import {
  Alert,
  Button,
  Snackbar,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";

import { tokens } from "../theme";
import { Formik } from "formik";
import * as yup from "yup";
import { useMediaQuery } from "@mui/material";
import { useState } from "react";
import { Box } from "@mui/material";
import { useAddLandingPageMutation } from "../features/auth/apiSlice";
import { useSelector } from "react-redux";
import { selectSponserID } from "../features/auth/authSlice";

const userSchema = yup.object().shape({
  title: yup.string().required("required"),
  description: yup.string().required("required"),
});

const AddLandingPageModal = ({
  setShowAddLandingPageModal,
  setData,
}: {
  setShowAddLandingPageModal: React.Dispatch<React.SetStateAction<boolean>>;
  setData: React.Dispatch<any>;
}) => {
  const sponserId = useSelector(selectSponserID);
  const [addLandingPageAPI] = useAddLandingPageMutation();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [initialValues, setInitialValues] = useState({
    title: "",
    description: "",
  });
  const [isOpen, setIsOpen] = useState(false);

  const handleFormSubmit = async (values: any) => {
    const response: any = await addLandingPageAPI({
      values,
      sponserId,
    }).unwrap();
    if (response.status === 201) {
      setData(response.landingPages);
      setIsOpen(true);
    }
  };

  return (
    <div className="flex flex-col justify-center items-center fixed left-0 top-0 right-0 bottom-0 bg-[rgba(0,0,0,0.5)] z-[3]">
      <div className="rounded-md p-[10px] bg-[#222222] border-[#eee]">
        <div className="p-[10px] flex justify-between">
          <Typography variant="h3" color={colors.grey[400]}>
            Add Landing Page
          </Typography>
          <div
            className="text-lg select-none hover:cursor-pointer"
            onClick={() => setShowAddLandingPageModal(false)}
            style={{ color: colors.grey[400] }}
          >
            X
          </div>
        </div>
        <div className="w-[500px]">
          <Formik
            onSubmit={handleFormSubmit}
            initialValues={initialValues}
            validationSchema={userSchema}
          >
            {/* @ts-ignore */}
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <Box
                    display={"grid"}
                    gap="8px"
                    gridTemplateColumns={"repeat(4, minmax(0,1fr))"}
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <TextField
                      fullWidth
                      variant="outlined"
                      type={"text"}
                      label="Page Title"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        handleChange(e);
                        setInitialValues({
                          ...initialValues,
                          title: e.target.value,
                        });
                      }}
                      value={initialValues.title}
                      name="title"
                      error={!!touched.title && !!errors.title}
                      helperText={touched.title && errors.title}
                      sx={{ gridColumn: "span 2" }}
                    />
                    <TextField
                      fullWidth
                      variant="outlined"
                      type={"text"}
                      label="Page Description"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        handleChange(e);
                        setInitialValues({
                          ...initialValues,
                          description: e.target.value,
                        });
                      }}
                      value={initialValues.description}
                      name="description"
                      error={!!touched.description && !!errors.description}
                      helperText={touched.description && errors.description}
                      sx={{ gridColumn: "span 2" }}
                    />
                  </Box>
                  <Box display="flex" justifyContent={"start"} mt="20px">
                    <Button type="submit" color="secondary" variant="contained">
                      Create
                    </Button>
                  </Box>
                  <Snackbar
                    open={isOpen}
                    autoHideDuration={6000}
                    onClose={() => {
                      setIsOpen(false);
                      setShowAddLandingPageModal(false);
                    }}
                    message="Note archived"
                  >
                    <Alert
                      onClose={() => {
                        setIsOpen(false);
                        setShowAddLandingPageModal(false);
                      }}
                      severity="success"
                      sx={{ width: "100%" }}
                    >
                      Landing page created successfully!
                    </Alert>
                  </Snackbar>
                </form>
              );
            }}
          </Formik>
        </div>
        <div className="p-[10px]"></div>
      </div>
    </div>
  );
};

export default AddLandingPageModal;
